export default __webpack_public_path__ + "static/media/logo_astcu.2dbbd634.svg";